import { render, staticRenderFns } from "./RelayMode.vue?vue&type=template&id=b0d28c2a&"
import script from "./RelayMode.vue?vue&type=script&lang=js&"
export * from "./RelayMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports